import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text7 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, floor} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(floor) && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>קומה: </span>
          <span>{floor}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text7;
